import { AiContainedIcon } from './ai-contained-icon';

export const Avatar = ({ as = 'div' }: { as?: React.ElementType }) => {
  return <AiContainedIcon iconName='aiweave-assistant' as={as} size={20} />;
};
